import { render, staticRenderFns } from "./SetConfigRoleInput.vue?vue&type=template&id=328c2f36&scoped=true"
import script from "./SetConfigRoleInput.vue?vue&type=script&lang=js"
export * from "./SetConfigRoleInput.vue?vue&type=script&lang=js"
import style0 from "./SetConfigRoleInput.vue?vue&type=style&index=0&id=328c2f36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328c2f36",
  null
  
)

export default component.exports